import React from 'react';
import { ExternalLink } from 'lucide-react';

const FooterMinimal = () => {
  return (
    <footer className="py-12 border-t">
      <div className="container">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <p className="text-2xl font-semibold mb-2">SOVEREIGN</p>
            <p className="text-sm text-muted-foreground">
              Building trust infrastructure for high-value markets
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-4">
            <a
              href="https://sovereigngroup.io"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Visit SovereignGroup.io
              <ExternalLink className="h-4 w-4" />
            </a>
            <p className="text-xs text-muted-foreground">
              © 2025 Sovereign. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterMinimal;
